// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2br4X","label":"Completed_label__3Uawe"};